import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={24}
    height={21}
    {...props}
    viewBox="0 0 24 21"
    {...props}
    fill="none"
    stroke="none">
    <Path
      stroke={props.fill || '#000'}
      strokeWidth={2}
      d="M6.336 1c1.282 0 2.517.513 3.43 1.434l.005.004.004.006c.39.382.722.81.995 1.28l.113.205.93 1.75.853-1.783.001-.001.008-.016a5.071 5.071 0 0 1 .242-.406c.184-.278.465-.651.846-1.022.758-.738 1.881-1.441 3.443-1.441h.317c1.489.082 2.812.725 3.718 1.768.965 1.111 1.511 2.738 1.206 4.783-.306 2.02-1.47 3.945-3.43 5.914-1.848 1.858-4.324 3.687-7.251 5.616-2.929-1.934-5.407-3.764-7.252-5.62-1.958-1.97-3.128-3.892-3.429-5.909-.306-2.045.241-3.673 1.206-4.784C3.264 1.658 4.715 1 6.336 1Z"
    />
  </Svg>
);
export default SvgComponent;
